module.exports = __webpack_public_path__ + "static/img/defaultImg.5b98405c.png";